import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { RecommendationEntity } from './entities/recommendation.entity';

@Injectable({
  providedIn: 'root',
})
export class RecommendationsApisService {
  private readonly baseUrl = `${environment.BACKEND_URL_API}/recommendations/products`;

  constructor(private http: HttpClient) {}

  getRecommendations(): Observable<RecommendationEntity[]> {
    return this.http.get<RecommendationEntity[]>(this.baseUrl);
  }
}
